import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';

const CheckEmailSchema = Yup.object().shape({
    email: Yup.string().email($t('Invalid email')).required($t('This value is required')),
});

export default function EvaluateCompaniesCheckEmail(props) {
    return (
        <Formik
            initialValues={{
                email: '',
            }}
            validationSchema={CheckEmailSchema}
            onSubmit={(values, actions) => {
                axios
                    .put(props.checkEmailUrl, values)
                    .then((response) => {
                        if (response.data.status) {
                            setTimeout(() => {
                                props.setEmailChecked(true);
                            }, 0);
                        } else {
                            actions.setErrors({ email: $t('Incorrect email') });
                        }
                    })
                    .catch((e) => {
                        actions.setErrors({ email: $t('Incorrect email') });
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="row d-flex justify-content-center my-3">
                        <div className="col-11">
                            <h4 className="py-3 px-5">
                                {$t('Please enter the email address you received the company evaluation link to access the evaluation.')}
                            </h4>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center my-3">
                        <div className="col-11">
                            <div className={'form-group'}>
                                <label htmlFor="email">
                                    {$t('Enter your email')} <span className="text-danger">*</span>
                                </label>
                                <Field
                                    type="email"
                                    className={errors.email && touched.email ? 'form-control is-invalid border border-danger' : 'form-control'}
                                    name="email"
                                    placeholder={$t('Email')}
                                />
                                {errors.email && touched.email && <div className="text-danger">{errors.email}</div>}
                            </div>
                            <Button variant="button" className="my-3" disabled={isSubmitting} onClick={handleSubmit}>
                                {$t('Get access')}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </Formik>
    );
}
